import { configureStore } from "@reduxjs/toolkit";
import { toastReduce, ToastStateType } from "./slices/toast";
import { configReducer, ConfigStateType } from "./slices/configSlice";
import { authReducer, AuthStateType } from "./slices/authSlice";


export const store = configureStore({
    reducer:{
        toast:toastReduce,
        config:configReducer,
        auth:authReducer
    }
})


export type RootStateType={
    toast:ToastStateType
    config:ConfigStateType
    auth:AuthStateType
}